// extracted by mini-css-extract-plugin
module.exports = {"form":"splash_form__w0yFz","err":"splash_err__3pas7","succ":"splash_succ__2Bpqw"};